import React from 'react';

import { isMobileMedia } from 'utils/media';

import MenuContainer from 'menus/containers/MenuContainer';
import OrderSettingRoute from 'menus/containers/OrderSettingRoute';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

/**
 * This container follows the same pattern as LocationDetailContainer.
 * If this is on mobile, we are displaying the LocationDetailRoute as
 * a page else we will render the menu container and render a
 * LocationDetailModal on top of the menu.
 */
class OrderSettingRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <OrderSettingRoute />;
    } else {
      return <MenuContainer shouldOpenOrderSettingModal />;
    }
  }
}

export default withGoogleLibraryLoaded(OrderSettingRouteContainer);
